var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWidgetsGraphElement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1574.6 990.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .35;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        fill: #f7146c;\n      }\n\n      .cls-8 {\n        fill: url(#radial-gradient);\n        opacity: .25;\n      }\n\n      .cls-9 {\n        stroke: #1823a0;\n        stroke-width: 11px;\n      }\n\n      .cls-9, .cls-10 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-11, .cls-3 {\n        opacity: .5;\n      }\n\n      .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16 {\n        fill: #1823a0;\n      }\n\n      .cls-12 {\n        opacity: .08;\n      }\n\n      .cls-4, .cls-13 {\n        opacity: .3;\n      }\n\n      .cls-17 {\n        fill: url(#radial-gradient-2);\n        opacity: .2;\n      }\n\n      .cls-5, .cls-16 {\n        opacity: .1;\n      }\n\n      .cls-6 {\n        opacity: .05;\n      }\n\n      .cls-14 {\n        opacity: .15;\n      }\n\n      .cls-10 {\n        stroke: #f7146c;\n        stroke-width: 10px;\n      }\n\n      .cls-7 {\n        opacity: .07;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 713.99,
    cy: -255.81,
    fx: 713.99,
    fy: -255.81,
    r: 168.84,
    gradientTransform: "translate(-663.54 -541.5) rotate(75.55) scale(2.1 4.34) skewX(4.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1823a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05061f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 711.64,
    cy: -323.49,
    fx: 711.64,
    fy: -323.49,
    r: 168.84,
    gradientTransform: "translate(-218.7 -662.61) rotate(75.21) scale(2.1 2.93) skewX(3.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7146c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05061f",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1135.46,
    y: 263.6,
    width: 275.12,
    height: 275.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 144.51,
    y: 702.42,
    width: 146.65,
    height: 146.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1402.99,
    y: 97.62,
    width: 52.29,
    height: 52.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 393.48,
    y: 644.21,
    width: 222.82,
    height: 93.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 587.5,
    y: 529.62,
    width: 203.12,
    height: 250.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 741.35,
    y: 440.95,
    width: 179.62,
    height: 136.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1302.95,
    y: 295.43,
    width: 241.01,
    height: 118.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 689.06,
    y: 409.12,
    width: 88.67,
    height: 88.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 276.38,
    y: 833.16,
    width: 35.24,
    height: 35.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 987.29,
    y: 564.86,
    width: 35.24,
    height: 35.24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M861.65,928.6c-396.92,118.68-757.83,63.03-806.11-124.3C7.25,616.98,289.87,368.92,686.79,250.24c396.92-118.68,757.83-63.03,806.11,124.3,48.29,187.32-234.33,435.39-631.25,554.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1158.21,837.33c-267.44,82.8-524.27-1.69-573.65-188.72-49.38-187.02,127.39-405.75,394.83-488.55,267.44-82.8,524.27,1.69,573.65,188.72,49.38,187.02-127.39,405.75-394.83,488.55Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M172.44,941.84c5-24,12-46,19-70,1-3,3-6,4-9,11-36,26-68,43-101,14-25,27-47,44-70,38-52,78-93,131-131,3-2,7-3,10-5,10-8,20-14,31-21,5-3,10-6,15-8,12-7,23-13,35-18,71-29,146-45,223-36h9c3,0,5,1,8,2h5c3,1,5,1,8,2h5c21,4,40,9,60,15,10,3,18,8,28,11,3,1,5,3,8,4,131,48,274,28,393-52,3-2,6-2,9-4,25-18,46-33,68-53,3-2,5-5,7-8,8-7,15-14,22-22,1-1,3-2,4-3,40-44,72-91,97-143,26-52,46-106,58-162"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1471.44,369.84c-138-31-282-24-419,19-3,1-6,3-9,4-29,8-54,21-81,32-1,1-3,2-4,3-5,2-9,4-14,6-20,11-38,20-57,33-6,4-11,7-17,11-20,14-37,27-56,42-5,5-10,9-15,13-25,23-47,46-72,70-5,4-10,8-15,13l-12,9c-3,2-4,5-7,7-18,14-34,25-53,38-6,4-11,7-17,11-2,1-3,1-5,2-175,108-378,131-571,90"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M880.83,512.93c58.39,18.29,116.25,21.77,176.78,15.13,43.46-6.2,83.71-17.07,124.22-34.76,18.58-9.48,37.11-17.83,55.74-28.44,8.13-4.22,15.13-8.48,23.3-13.84,14.04-9.67,25.76-18.29,38.66-28,1.18-1.09,2.41-3.31,3.59-4.4,42.25-32.4,74.42-68.62,105.74-111.7,7.23-9.94,12.14-18.84,18.18-27.69,31.54-48.76,52.82-96.79,70.93-150.64,7.73-22.43,12.11-46.13,18.7-68.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M172.01,942.46c26.45-119.47,81.01-230.97,168.75-319.52,36.81-38.31,76.7-68.53,123.17-92.8,48.83-26.45,96.21-45,152.25-52.96"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1445.75,
    cy: 27.16,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1567.6,
    cy: 132.48,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1295.16,
    cy: 285.58,
    r: 4.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1492.42,
    cy: 270.42,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 370.74,
    cy: 872.19,
    r: 6.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 351.04,
    cy: 722.13,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 469.72,
    cy: 787.43,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1035.21,
    cy: 362.25,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 695.12,
    cy: 575.09,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1122.19,
    cy: 435.23,
    r: 1.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1441.65,
    cy: 387.52,
    r: 1.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 140.76,
    cy: 717.58,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1508.19,
    cy: 3.72,
    r: 3.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1124.68,
    cy: 569.03,
    r: 5.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 175.08,
    cy: 766.39,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 676.03,
    cy: 434.13,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 681.48,
    cy: 694.84,
    r: 5.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 3.65,
    cy: 808.99,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 439.4,
    cy: 583.74,
    r: 5.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1051.33,
    cy: 493.69,
    r: 2.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 118.67,
    cy: 849.45,
    r: 2.58
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetsGraphElement);
export default __webpack_public_path__ + "static/media/widgets_graph_element.efa5851eb9bd91ca2c5c97780bdf289e.svg";
export { ForwardRef as ReactComponent };